"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_THEME = void 0;
var palette_1 = require("./palette");
exports.DEFAULT_THEME = {
    palette: {
        primary: palette_1.primary,
        secondary: palette_1.secondary,
        tertiary: palette_1.tertiary,
        light: palette_1.light,
        dark: palette_1.dark,
        safe: palette_1.safe,
        danger: palette_1.danger,
        warn: palette_1.warn,
    },
};
